import React, { Fragment } from "react";

import FundReopenNotifications from "../fund-reopen-notifications/FundReopenNotifications";
import OtherHelp from "./OtherHelp";

const DiseaseFundClosedCard = ({ data }) => {
  return (
    <div className="FundClosedCard Card bg-coral-light-50">
      <div className="Card-inner">
        <div className="Card-inner-content">
          <div className="f-scale-body">
            {data.Fund_Status === "Closed, wait list available" && (
              <Fragment>
                <p className="f-h3">
                  Sign up for the wait list
                </p>
                <p className="u-mt1 u-mb2">
                  Sign up for the wait list to be notified by email when this
                  fund opens.
                </p>
                <FundReopenNotifications data={data} />
                <hr className="Card-hr u-mt4 u-mb4" />
              </Fragment>
            )}

            <OtherHelp data={data} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiseaseFundClosedCard;
